import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';

@Component({
  selector: 'app-create-product',
  templateUrl: './create-product.component.html',
  styleUrls: ['./create-product.component.scss']
})
export class CreateProductComponent implements OnInit {

  prodFormGroup;
  submitted = false;
  fileToUpload: any;

  reward_details:any={
    reward_products:[],
    product_types: [],
    brands:[],
    reward_brand:[],
    reward_categories:[],
    reward_sub_categories:[],
    reward_brands:[],
    price_type:[]
  };
  reward_detailsSelected = {
    reward_product:'',
    product_type:'',
    reward_brand:'',
    reward_category:'',
    reward_sub_category:'',
    price_type:''
  }


  price_slab=[
    {
        "denominations":0,
        "mrp":0,
        "points":0
    },
  ];

  constructor(private router :Router,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private fb: FormBuilder,
    private toast: ToastClientService,

    ) { }

  ngOnInit() {
    this.getAllRewards();


    this.prodFormGroup = this.fb.group({
      program_id: 1,
      prod_name: new FormControl('', [Validators.required]),
      product_type: new FormControl('', [Validators.required]),
      reward_category_id: new FormControl('', [Validators.required]),
      reward_sub_categoryid: new FormControl('', [Validators.required]),
      reward_brand_id: new FormControl('', [Validators.required]),
      sku: new FormControl('', [Validators.required]),
      description: new FormControl(''),
      min_custom_price: new FormControl(''),
      max_custom_price: new FormControl(''),
      base_image: new FormControl(''),
      price_type: new FormControl('', [Validators.required]),
    });

  }


  get f() {
    return this.prodFormGroup.controls
  }

  getAllRewards() {
    this.apiService.get(this.apiConfig.getRewardProducts).subscribe(
      (res: any) => {
        this.reward_details = res.data;
        // this.reward_detailsSelected.product_type = this.reward_details.product_types[0].id;
        // this.reward_detailsSelected.reward_category = this.reward_details.reward_categories[0].id;
        // this.reward_detailsSelected.reward_sub_category = this.reward_details.reward_sub_categories[0].id;
        // this.reward_detailsSelected.reward_brand = this.reward_details.reward_brands[0].id;
        // this.reward_detailsSelected.price_type = this.reward_details.price_type[1].id;
        // console.log(this.reward_details)
      },
      (err) => {
        console.log(err);
      }
    );
  }




  imageChange(img) {

    console.log(img)
    var file = img.target.files[0];
    var reader = new FileReader();
    var self = this;
    reader.onloadend = function () {
      //self.AddOffer.controls['offer_image'].setValue(reader.result);
      self.prodFormGroup.value.offer_image = reader.result;
      self.fileToUpload = reader.result;
    }
    reader.readAsDataURL(file);

  }


  onSubmitReward(formData:any) {
    this.submitted = true;

    console.log(formData)
    if (this.prodFormGroup.invalid) {
      return;
    }
   formData.base_image = this.fileToUpload;
   formData.price_slab = JSON.stringify(this.price_slab) ;

    console.log(formData)

    this.apiService.post(this.apiConfig.createRewardProducts, formData)
      .subscribe((res: any) => {
        this.toast.Success('Reward Product added successfully')
        this.router.navigateByUrl('/hubAdmin/reward-products')
      }, err => {
        this.toast.Error('Error adding Reward Product');
      })

     }


     addPriceSlab()
     {
          let obj={
            "denominations":0,
            "mrp":0,
            "points":0
          }
          this.price_slab.push(obj)
          console.log(this.price_slab)
     }

     removePriceSlab(obj)
     {
       if(this.price_slab.length==1)
       {
         this.toast.Error("Cant be Deleted")
         return;
       }
      this.price_slab = this.price_slab.filter(o => o !== obj);
     }

     onChangeEachItem(val,name,index){
      this.price_slab[index][name]= Number(val);
      console.log(this.price_slab);
    }
    rewardCategoryChanged(eve){
      this.getSubCategories(eve);
      this.getRewadBrands(eve);
    }
    getSubCategories(eve){
      console.log(this.apiConfig.getRewardSubCategory+eve);
      this.apiService.get(this.apiConfig.getRewardSubCategory+eve).subscribe(
        (res: any) => {
          console.log(res);
          if(res.data){
            this.reward_details.reward_sub_categories = res.data.reward_sub_categories;
          }
        },
        (err) => {
          console.log(err);
        }
      );
    }
    getRewadBrands(eve){
      console.log(eve);
      this.apiService.get(this.apiConfig.getRewardsBrands+eve).subscribe(
        (res: any) => {
          console.log(res);
          if(res.data){
            this.reward_details.reward_brands = res.data.reward_brands;
          }
        },
        (err) => {
          console.log(err);
        }
      );
    }
}
